document.addEventListener('DOMContentLoaded', () => {
    new VanillaTabs({
        'selector': '.faq-list',
        'type': 'accordion',
        'activeIndex': 0, // tab 2
    });
});
